export default __webpack_public_path__ + "static/media/014-shopping-carts-1.371ff211.png";